<template>
  <v-banner class="choiceBanner">
    <p class="headline text-center">
      {{ $t("message.stakeholderChoice") }}
    </p>
    <v-btn
      large
      color="primary"
      @click="navigateToStakeholderLookUp()"
    >
      {{ $t("message.finish") }}
    </v-btn>
    <v-divider />
    <SurveySelectDropdown @set-survey="setSurvey" />
    <v-btn
      large
      color="success"
      :disabled="Object.entries(surveyToNavigateTo).length === 0"
      @click="navigateToSurvey"
    >
      {{ $t("message.nextSurvey") }}
    </v-btn>
  </v-banner>
</template>

<script>
import SurveySelectDropdown from "@/components/StakeholderLookup/SurveySelectDropdown.vue";

export default {
  name: "StakeholderChoice",
  components: {
    SurveySelectDropdown
  },
  data: () => ({
    surveyToNavigateTo: {}
  }),
  methods: {
    setSurvey(survey) {
      this.surveyToNavigateTo = survey;
    },
    setHasCompleted(value) {
      this.$emit("set-has-completed", value);
    },
    navigateToStakeholderLookUp() {
      const programNameFromURL = this.$router.currentRoute.params.program_name;
      this.$router.push({ name: "ViewMultipleSurveys", path: "/" + programNameFromURL, params: {program_name: programNameFromURL}})
    },
    navigateToSurvey() {
      this.setHasCompleted(false)
      const dashboardFiltering = this.surveyToNavigateTo.survey_metadata.meta_data.dashboardFiltering;
      const routerParams = {
        program_name: this.$router.currentRoute.params.program_name,
        project_name: this.formatName(dashboardFiltering.project),
        survey_name: this.formatName(dashboardFiltering.survey)
      };
      this.$router.push({
        name: "survey",
        params: routerParams
      })
    },
    formatName(name) {
      return (name).replace(/ /g, "_")
    },
  }
};
</script>

<style>
.choiceBanner .v-banner__text {
  width: 100%;
}
</style>
